module.exports = __webpack_public_path__ + "static/media/backIcon.4a29db41.svg";